import type { ApexOptions } from 'apexcharts'
import type { SectionMetrics } from '../../../features/engagement/domain/models/sections'
import { buildDonutChartOptions, type DonutChartItem } from '../../shared/charts'
import { formatDurationHours, SECTION_COLORS, SECTION_LABEL_KEYS, type TranslateFn } from './section-display'

// Time share by section: includes 'other', drops zero-time slices
export const getSectionsTimeDonutItems = (sections: SectionMetrics[], t: TranslateFn): DonutChartItem[] =>
  sections
    .filter((s) => s.seconds.current > 0)
    .map((s) => ({
      name: t(SECTION_LABEL_KEYS[s.section]),
      value: s.seconds.current,
      color: SECTION_COLORS[s.section]
    }))

export const getSectionsTimeDonutOptions = (items: DonutChartItem[]): ApexOptions => {
  const options = buildDonutChartOptions({ items })

  // Values are seconds of time spent — tooltip shows them as hours/minutes
  return {
    ...options,
    tooltip: {
      enabled: true,
      y: {
        formatter: (value: number) => formatDurationHours(value)
      }
    }
  }
}
